import { League } from '../models';
import { LeagueRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class CreateLeagueUseCase {
  constructor(
    private leagueRepository: LeagueRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(params: {
    name: string;
    description?: string;
    logoUrl?: string;
    pointSystem?: number[];
    isPublic?: boolean;
    userId: string;
  }): Promise<League> {
    const { name, description, logoUrl, pointSystem, isPublic, userId } = params;

    if (!name.trim()) {
      throw new Error('League name is required');
    }

    // Moderate content before writing
    await this.moderateContent.execute(name, 'league_name', userId);
    if (description) {
      await this.moderateContent.execute(description, 'league_description', userId);
    }

    const leagueData = {
      name: name.trim(),
      description: description?.trim(),
      logoUrl,
      status: 'setup' as const,
      pointSystem: pointSystem || [25, 18, 15, 12, 10, 8, 6, 4, 2, 1],
      isPublic: isPublic ?? false,
      userId,
    };

    return await this.leagueRepository.create(leagueData);
  }
}
